import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";

function useCustomAddressDetail(id) {
  return useSWR(
    !id
      ? null
      : {
          path: `/api/v1/customers/${id}/addresses`,
          method: "GET",
          params: {
            limit: 200,
            skip: 0,
          },
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useCustomAddressDetail;
